var React = require('react');

function ReadMoreArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.5303 6.53033C17.8232 6.23744 17.8232 5.76257 17.5303 5.46967L12.7574 0.696701C12.4645 0.403808 11.9896 0.403808 11.6967 0.696701C11.4038 0.989594 11.4038 1.46447 11.6967 1.75736L15.9393 6L11.6967 10.2426C11.4038 10.5355 11.4038 11.0104 11.6967 11.3033C11.9896 11.5962 12.4645 11.5962 12.7574 11.3033L17.5303 6.53033ZM-1.32236e-07 6.75L17 6.75L17 5.25L1.32236e-07 5.25L-1.32236e-07 6.75Z","fill":"#CECACA"}));
}

ReadMoreArrow.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = ReadMoreArrow;

ReadMoreArrow.default = ReadMoreArrow;
